import { useLocale } from '@radical/locale'
import { LAYOUT } from '../basic'

const { getLocale } = useLocale()

const device: RouteRecordItem = {
  path: '/device',
  name: 'Device',
  component: LAYOUT,
  redirect: { name: 'GBDevice' },
  meta: {
    orderNo: 2,
    icon: 'material-symbols:camera-video-rounded',
    title: '国标设备',
    // 非中文环境下隐藏该菜单
    hideMenu: getLocale.value !== 'zh_CN',
    hideChildrenInMenu: getLocale.value !== 'zh_CN',
  },
  children: [
    {
      path: 'gb28181',
      name: 'GBDevice',
      component: () => import('@/pages/device/gb28181.vue'),
      meta: {
        title: '设备管理',
        icon: 'material-symbols:camera-video-rounded',
      },
    },
    {
      path: 'screen-gb',
      name: 'ScreenGB',
      component: () => import('@/pages/screen/gb28181.vue'),
      meta: {
        title: '设备分屏',
        icon: 'icon-park-solid:one-to-many',
      },
    },
    {
      path: 'screen-group',
      name: 'ScreenGroup',
      component: () => import('@/pages/screen/group.vue'),
      meta: {
        title: '设备分组',
        icon: 'fluent:group-list-20-filled',
      },
    },
    {
      path: 'record',
      name: 'RecordGb28181',
      component: () => import('@/pages/record/index.vue'),
      meta: {
        title: '录像管理',
        icon: 'gridicons:video',
      },
    },
    {
      path: 'alarms',
      name: 'Alarms',
      component: () => import('@/pages/alarms/index.vue'),
      meta: {
        title: '报警查询',
        icon: 'typcn:warning',
      },
    },
    {
      path: 'cascade',
      name: 'Cascade',
      component: () => import('@/pages/cascade/index.vue'),
      meta: {
        title: '国标级联',
        icon: 'mdi:file-tree',
      },
    },
    {
      path: 'channel',
      name: 'Channel',
      component: () => import('@/pages/channel/index.vue'),
      meta: {
        title: '通道管理',
        icon: 'mdi:lan',
      },
    },
  ],
}

export default device
